// 教科コードから表示順を決める

// 教科のオーダー
const subjectOrders = [
  'L',
  'L2',
  'M',
  'M2',
  'P',
  'P2',
  'J',
  'J2',
  'E',
  'E2',
  '2',
  '20',
  'S2',
  '3',
  'S3',
  'S3P',
  '3P',
  'S3J',
  '3J',
  '4',
  '40',
  'S4',
  '5',
  '50',
  'S5',
]

const compareSubjectOrder = (a: string, b: string) => {
  return subjectOrders.indexOf(a) - subjectOrders.indexOf(b)
}

export default compareSubjectOrder
